import { ValueDisplayValue } from "@mcleod/core";
import { RadioOption } from "./RadioOption";
import { RadioGroup } from "./RadioGroup";

export class RadioOptionResolver {
    static resolveOptions(group: RadioGroup, value: ValueDisplayValue[] | (() => ValueDisplayValue[]) |
        RadioOption[] | (() => RadioOption[])): RadioOption[] {
        const array = ((typeof value === "function") ? value() : value) ?? [];
        return array.map((item: ValueDisplayValue | RadioOption) => this.resolveOption(group, item));
    }

    static resolveOption(group: RadioGroup, value: ValueDisplayValue | RadioOption): RadioOption {
        let result: RadioOption;
        try {
            if (value instanceof group.optionClass) {
                result = value;
                return result;
            }
            let valueDisplayValue: ValueDisplayValue = value instanceof ValueDisplayValue ? value : null;
            // If value is a serialized ValueDisplayValue, it won't be an instance of the class yet.
            // We need to create one.
            if (valueDisplayValue == null && value?.value != null && value?.displayValue != null)
                valueDisplayValue = new ValueDisplayValue(value.value, value.displayValue, value["addlValues"]);
            // Now that we have the real ValueDisplayValue object, create a RadioButton with that object.
            result = new group.optionClass({ valueDisplayValue }) as RadioOption;
            return result;
        }
        finally {
            if (result != null) {
                result._designer = group._designer;
                result.alternateDesignerTarget = group;
            }
        }
    }
}
